import request from '@/utils/httpRequest'

export function list(param) {
    return request({
        url: '/app/business/onsiteinfo/list',
        method: 'get',
        params: param
    })
}

export function save(data) {
    return request({
        url: '/app/business/onsiteinfo/save',
        method: 'post',
        data
    })
}

export function info(id) {
    return request({
        url: '/app/business/onsiteinfo/info/' + id,
        method: 'get'
    })
}

export function update(data) {
    return request({
        url: '/app/business/onsiteinfo/update',
        method: 'post',
        data
    })
}
